import { createContext, useContext, type ReactNode } from 'react';

import type { SessionWorkPanelEvidenceChrome } from './SessionWorkPanelHeader';

/** The session header's Evidence chrome, read as a hook so the queries stay with the caller. */
export type UseSessionWorkPanelEvidenceChrome = (options: {
  sessionId: string;
  evidenceChatId: string | null | undefined;
  onSelectProject?: (projectId: string) => void;
}) => SessionWorkPanelEvidenceChrome;

const stubChrome: UseSessionWorkPanelEvidenceChrome = ({ onSelectProject }) => ({
  isEvidence: false,
  evidenceChatTitle: undefined,
  evidenceChats: [],
  openEvidenceChat: () => undefined,
  startNewEvidenceChat: () => undefined,
  handleSelectProject: (projectId) => {
    onSelectProject?.(projectId);
  },
});

const SessionWorkPanelEvidenceChromeContext =
  createContext<UseSessionWorkPanelEvidenceChrome>(stubChrome);

export const SessionWorkPanelEvidenceChromeProvider = ({
  useChrome,
  children,
}: {
  useChrome: UseSessionWorkPanelEvidenceChrome;
  children: ReactNode;
}): JSX.Element => (
  <SessionWorkPanelEvidenceChromeContext.Provider value={useChrome}>
    {children}
  </SessionWorkPanelEvidenceChromeContext.Provider>
);

/** Package-internal. With no provider this returns the no-query stub. */
export const useSessionWorkPanelEvidenceChrome: UseSessionWorkPanelEvidenceChrome = (
  options
) => useContext(SessionWorkPanelEvidenceChromeContext)(options);
